// removed by extract-text-webpack-plugin
module.exports = {"borderRadius":"4px","borderWidth":"1px","unit":"5px","colorSecondaryRagRed":"#d2222d","oldColorBlack":"#4a4a4a","oldColorWhite":"#ffffff","error":"text-input__error____2rrof","caption":"fonts__caption____HpZ4e","textInput":"text-input__textInput____2p805","input":"text-input__input____27FBG fonts__caption____HpZ4e","errorMessage":"text-input__errorMessage____1--bC fonts__error____u8e3y fonts__caption____HpZ4e fonts__bold____2QXwg"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/widgets/text-input/text-input.css
// module id = 416
// module chunks = 0